"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GREENS_POLICY_4 = exports.GREENS_POLICY_3 = exports.GREENS_POLICY_2 = exports.GREENS_DEFAULT_POLICY = exports.GREENS_BONUS_2 = exports.GREENS_BONUS_1 = exports.Greens = void 0;
const Party_1 = require("./Party");
const PartyName_1 = require("./PartyName");
const Tags_1 = require("../../cards/Tags");
const Resources_1 = require("../../Resources");
const TileType_1 = require("../../TileType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectCard_1 = require("../../inputs/SelectCard");
const SelectOption_1 = require("../../inputs/SelectOption");
const ResourceType_1 = require("../../ResourceType");
const Phase_1 = require("../../Phase");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const TurmoilPolicy_1 = require("../TurmoilPolicy");
const MarsCoalition_1 = require("../../cards/community/corporations/MarsCoalition");
const GreensPolicy4Action_1 = require("../../cards/turmoil/standardActions/GreensPolicy4Action");
class Greens extends Party_1.Party {
    constructor() {
        super(...arguments);
        this.name = PartyName_1.PartyName.GREENS;
        this.description = 'Wants to see a new Earth as soon as possible.';
        this.bonuses = [exports.GREENS_BONUS_1, exports.GREENS_BONUS_2];
        this.policies = [exports.GREENS_DEFAULT_POLICY, exports.GREENS_POLICY_2, exports.GREENS_POLICY_3, exports.GREENS_POLICY_4];
    }
}
exports.Greens = Greens;
class GreensBonus01 {
    constructor() {
        this.isDefault = true;
        this.id = 'gb01';
        this.description = 'Gain 1 M€ for each Plant, Microbe and Animal tag you have';
    }
    getScore(player) {
        return player.getTagCount(Tags_1.Tags.PLANT, 'raw') + player.getTagCount(Tags_1.Tags.MICROBE, 'raw') + player.getTagCount(Tags_1.Tags.ANIMAL, 'raw');
    }
    grant(game) {
        game.getPlayers().forEach((player) => {
            player.addResource(Resources_1.Resources.MEGACREDITS, this.getScore(player));
        });
    }
}
class GreensBonus02 {
    constructor() {
        this.id = 'gb02';
        this.description = 'Gain 2 M€ for each greenery tile you have';
        this.isDefault = false;
    }
    getScore(player) {
        const boardSpaces = player.game.board.spaces;
        const count = boardSpaces.filter((space) => space.tile && space.tile.tileType === TileType_1.TileType.GREENERY && space.player !== undefined && space.player.id === player.id).length;
        return count * 2;
    }
    grant(game) {
        game.getPlayers().forEach((player) => {
            player.addResource(Resources_1.Resources.MEGACREDITS, this.getScore(player));
        });
    }
}
class GreensPolicy01 {
    constructor() {
        this.isDefault = true;
        this.id = TurmoilPolicy_1.TurmoilPolicy.GREENS_DEFAULT_POLICY;
        this.description = 'When you place a greenery tile, gain 4 M€';
    }
    onTilePlaced(player, space) {
        var _a;
        if (((_a = space.tile) === null || _a === void 0 ? void 0 : _a.tileType) === TileType_1.TileType.GREENERY && player.game.phase === Phase_1.Phase.ACTION) {
            player.addResource(Resources_1.Resources.MEGACREDITS, 4);
        }
    }
}
class GreensPolicy02 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.GREENS_POLICY_2;
        this.description = 'When you place a tile, gain 1 plant';
        this.isDefault = false;
    }
    onTilePlaced(player) {
        player.addResource(Resources_1.Resources.PLANTS, 1);
    }
}
class GreensPolicy03 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.GREENS_POLICY_3;
        this.description = 'When you play an animal, plant or microbe tag, gain 2 M€';
        this.isDefault = false;
    }
    onCardPlayed(player, card) {
        const tags = [Tags_1.Tags.ANIMAL, Tags_1.Tags.PLANT, Tags_1.Tags.MICROBE];
        const tagCount = card.tags.filter((tag) => tags.includes(tag)).length;
        player.addResource(Resources_1.Resources.MEGACREDITS, tagCount * 2);
    }
}
class GreensPolicy04 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.GREENS_POLICY_4;
        this.description = 'Spend 5 M€ to gain 3 plants or add 2 microbes to ANY card';
        this.isDefault = false;
    }
    canAct(player, isDominantPartyAction = false) {
        return player.canAfford(5) && player.canUseTripleTurmoilAction(isDominantPartyAction);
    }
    action(player, isDominantPartyAction = false) {
        const game = player.game;
        game.log('${0} used Turmoil ${1} action', (b) => b.player(player).card(new GreensPolicy4Action_1.GreensPolicy4Action()));
        MarsCoalition_1.MarsCoalition.handleTripleUsePolicyLogic(player, isDominantPartyAction);
        game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 5, {
            title: 'Select how to pay for Turmoil Greens action',
            afterPay: () => {
                const availableMicrobeCards = player.getResourceCards(ResourceType_1.ResourceType.MICROBE);
                const orOptions = new OrOptions_1.OrOptions();
                if (availableMicrobeCards.length === 1) {
                    orOptions.options.push(new SelectOption_1.SelectOption('Add 2 microbes to ' + availableMicrobeCards[0].name, 'Confirm', () => {
                        player.addResourceTo(availableMicrobeCards[0], { qty: 2, log: true });
                        return undefined;
                    }));
                }
                else if (availableMicrobeCards.length > 1) {
                    orOptions.options.push(new SelectOption_1.SelectOption('Add 2 microbes to a card', 'Confirm', () => {
                        return new SelectCard_1.SelectCard('Select card to add 2 microbes', 'Add microbes', availableMicrobeCards, (foundCards) => {
                            player.addResourceTo(foundCards[0], { qty: 2, log: true });
                            return undefined;
                        });
                    }));
                }
                orOptions.options.push(new SelectOption_1.SelectOption('Gain 3 plants', 'Confirm', () => {
                    player.addResource(Resources_1.Resources.PLANTS, 3);
                    game.log('${0} gained 3 plants', (b) => b.player(player));
                    return undefined;
                }));
                if (orOptions.options.length === 1)
                    return orOptions.options[0].cb();
                game.defer(new DeferredAction_1.DeferredAction(player, () => orOptions));
                return undefined;
            },
        }));
        return undefined;
    }
}
exports.GREENS_BONUS_1 = new GreensBonus01();
exports.GREENS_BONUS_2 = new GreensBonus02();
exports.GREENS_DEFAULT_POLICY = new GreensPolicy01();
exports.GREENS_POLICY_2 = new GreensPolicy02();
exports.GREENS_POLICY_3 = new GreensPolicy03();
exports.GREENS_POLICY_4 = new GreensPolicy04();
//# sourceMappingURL=Greens.js.map